module.exports = __webpack_public_path__ + "static/media/moovi.988baa9f.png";